import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';
import { Typography, Link, Paper, Box } from '@mui/material';

const NetworkAdminWelcome = ({ firstName }) => {
    return (
        <Box mt={12} paddingX={8}>
            <Paper elevation={0}>
                <Box paddingX={10} paddingY={12}>
                    <Typography gutterBottom>
                        {texts.CHERE} {firstName},
                    </Typography>
                    <br></br>
                    <Typography>{texts.NETWORK_AMIN_ACCOUNT_ACTIVATED}</Typography>
                    <Typography>{texts.NETWORK_AMIN_ACCOUNT_INFO_1}</Typography>
                    <Typography>{texts.NETWORK_AMIN_ACCOUNT_INFO_2}</Typography>
                    <br></br>
                    <Typography gutterBottom>
                        {texts.PLATFORM_TEAM_AVAILABLE_BY_EMAIL}{' '}
                        <Link underline="hover" href="mailto:contact@petech.fr">
                            contact@petech.fr
                        </Link>
                        .
                    </Typography>
                    <br></br>
                    <Typography>{texts.CORDIALEMENT}</Typography>
                    <Typography>{texts.PEQAN_TEAM}</Typography>
                </Box>
            </Paper>
        </Box>
    );
};

NetworkAdminWelcome.propTypes = {
    firstName: PropTypes.string,
};

export default NetworkAdminWelcome;
